import { ConsoleLogger } from "@aderant/aderant-web-fw-applications";
import ClearIcon from "@mui/icons-material/Clear";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Divider, Grid, InputAdornment, TextField, styled } from "@mui/material";
import React, { useState } from "react";
import { Button } from "../../Button/Button";
import { Checkbox } from "../../Checkbox/Checkbox";
import { DateRangePicker } from "../../DateRangePicker/DateRangePicker";
import aderantTheme from "../../Theme/AderantTheme";
import { getLocalDateFormat, isGreaterThanOrEqual, resetTimeOnDate } from "../../Utils";
import { Messages } from "../Messages";
import { RefinerGroupType } from "../RefinerGroup";
const strings = {
    ShowMore: "Show More",
    ShowLess: "Show Less",
    SearchFor: "Search for {0}",
    NoResultsFound: "No results found"
};
const classes = {
    refinerGroup: "refinerGroup",
    expandCollapseCaretIcon: "expandCollapseCaretIcon",
    checkbox: "checkbox",
    title: "title",
    showHideSelector: "showHideSelector",
    optionRow: "optionRow",
    valueCheckbox: "valueCheckbox",
    valueText: "valueText",
    secondaryText: "secondaryText",
    valueCount: "valueCount",
    valueCountText: "valueCountText",
    filterBox: "filterBox",
    divider: "divider",
    dividerPadded: "dividerPadded",
    dateRangePicker: "dateRangePicker"
};
const StyledDiv = styled("div")(({ theme }) => ({
    [`& .${classes.refinerGroup}`]: {
        paddingTop: "10px"
    },
    [`& .${classes.expandCollapseCaretIcon}`]: {
        float: "right"
    },
    [`& .${classes.checkbox}`]: {
        padding: "0px"
    },
    [`& .${classes.title}`]: {
        color: theme.palette.primary.main
    },
    [`& .${classes.showHideSelector}`]: {
        marginTop: "3px",
        color: theme.palette.primary.main
    },
    [`& .${classes.optionRow}`]: {
        marginTop: "3px",
        flexWrap: "nowrap"
    },
    [`& .${classes.valueCheckbox}`]: {
        flex: "0 0 30px"
    },
    [`& .${classes.valueText}`]: {
        flex: "1 1 auto",
        paddingLeft: "7px",
        display: "flex",
        flexWrap: "wrap"
    },
    [`& .${classes.secondaryText}`]: {
        paddingLeft: "3px",
        color: aderantTheme.palette.text.secondary,
        fontStyle: "italic",
        fontSize: 12
    },
    [`& .${classes.valueCount}`]: {
        flex: "0 0 35px",
        marginRight: "9px"
    },
    [`& .${classes.valueCountText}`]: {
        float: "right"
    },
    [`& .${classes.filterBox}`]: {
        width: "100%",
        marginTop: "5px",
        marginBottom: "8px",
        "& .MuiOutlinedInput-root": {
            "&:hover fieldset": {
                borderColor: aderantTheme.palette.primary.main
            },
            "&.Mui-focused fieldset": {
                borderColor: aderantTheme.palette.text.black,
                borderWidth: "1px"
            }
        }
    },
    [`& .${classes.divider}`]: {
        marginTop: "10px"
    },
    [`& .${classes.dividerPadded}`]: {
        margin: "6px 0 0 0"
    },
    [`& .${classes.dateRangePicker}`]: {
        "& .MuiInput-input": {
            fontSize: "0.75rem",
            paddingLeft: "0px",
            paddingRight: "0px"
        }
    }
}));
const logger = new ConsoleLogger();
export function RefinerGroupDisplay(props) {
    const toggleExpanded = () => {
        if (props.disabled) {
            return;
        }
        props.setIsExpanded(!props.isExpanded);
    };
    let body = null;
    switch (props.refinerGroup.refinerGroupType) {
        case RefinerGroupType.ListRefiner:
            body = (React.createElement(ListRefinerGroupBody, { refinerGroup: props.refinerGroup, 
                // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onOptionSelectionChanged: props.onOptionSelectionChanged, 
                // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                numOptionsShown: props.numOptionsShown, isExpanded: props.isExpanded, setIsExpanded: props.setIsExpanded, disabled: props.disabled }));
            break;
        case RefinerGroupType.DateRange:
            body = (React.createElement(DateRangeRefinerGroupBody
            // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            , { 
                // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDateSelectionChanged: props.onDateSelectionChanged, refinerGroup: props.refinerGroup, isExpanded: props.isExpanded, disabled: props.disabled }));
            break;
        default:
            logger.warn(`Cannot get body for refiner group`);
            break;
    }
    return (React.createElement(StyledDiv, null,
        React.createElement(Grid, { container: true, direction: "column", className: classes.refinerGroup },
            React.createElement(Grid, { item: true, container: true },
                React.createElement(Grid, { item: true, container: true, direction: "row", onClick: toggleExpanded, style: { cursor: props.disabled ? "auto" : "pointer", justifyContent: "space-between" }, className: `${classes.title} refinerGroupHeader` },
                    React.createElement(Grid, { item: true, style: { alignSelf: "center" } },
                        React.createElement("span", { className: "title" }, props.refinerGroup.name)),
                    React.createElement(Grid, { item: true },
                        React.createElement(Button, { iconButton: true, startIcon: props.isExpanded ? React.createElement(ExpandLessIcon, { className: classes.expandCollapseCaretIcon }) : React.createElement(ExpandMoreIcon, { className: classes.expandCollapseCaretIcon }), onClick: toggleExpanded, variant: "plain", rounded: true, "aria-label": Messages.EXPAND_COLLAPSE_GROUP.getMessage([props.isExpanded ? "Less" : "More"]), disabled: props.disabled })))),
            body,
            React.createElement(Divider, { className: classes.divider }))));
}
function ListRefinerGroupBody(props) {
    const [searchText, setFilterText] = useState("");
    const [isShowingAll, setIsShowingAll] = useState(false);
    const { isExpanded } = props;
    const hasEnteredSearchText = () => {
        return searchText && searchText.trim().length > 0;
    };
    const getTextForTextComparison = (value) => {
        return getValueAsString(value).trim().toLowerCase();
    };
    const toggleShowingAll = () => {
        if (props.disabled) {
            return;
        }
        setIsShowingAll(!isShowingAll);
    };
    const getValueAsString = (value) => {
        if (value === null || value === undefined) {
            return "";
        }
        if (typeof value === "string") {
            return value;
        }
        /* eslint-disable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call*/
        /* value is already null/undefined checked, and all other js types have a toString method*/
        return value.toString() || "";
        /* eslint-enable @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call*/
    };
    const schText = getTextForTextComparison(searchText);
    let regex;
    try {
        regex = new RegExp(schText);
    }
    catch (e) {
        logger.debug(`Invalid regex expression was ignored for refiner filter and only basic search will occur: ${schText}`);
    }
    const refinerOptionsToShow = props.refinerGroup.refinerOptions
        .slice() //Copy array
        .sort((a, b) => b.count - a.count) //Descending sort
        .filter((option) => {
        if (option.count == 0) {
            return false;
        }
        if (!schText) {
            return true;
        }
        const value = getTextForTextComparison(option.value);
        return value.startsWith(schText) || value.endsWith(schText) || (regex && value.search(regex) > -1);
    });
    const numOptions = refinerOptionsToShow.length;
    //The show more text takes up the same space as another row, so if there are max + 1 items,
    //just show the extra item instead
    let numOptionsToShow = 0;
    let showOptionsExpansion = false;
    // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    if (numOptions <= props.numOptionsShown + 1) {
        numOptionsToShow = numOptions;
    }
    else if (isShowingAll) {
        numOptionsToShow = numOptions;
        showOptionsExpansion = true;
    }
    else {
        // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        numOptionsToShow = props.numOptionsShown;
        showOptionsExpansion = true;
    }
    const refinerRows = refinerOptionsToShow.slice(0, numOptionsToShow).map((option) => {
        const onChange = (event) => {
            const newValue = event.target.checked || false;
            props.onOptionSelectionChanged(getValueAsString(option.value), newValue);
        };
        return (React.createElement(Grid, { item: true, container: true, className: `${classes.optionRow} option-row`, alignItems: "center", key: getValueAsString(option.value) },
            React.createElement(Grid, { item: true, className: classes.valueCheckbox },
                React.createElement(Checkbox, { disabled: props.disabled, compact: true, checked: option.isSelected, onChange: onChange, "aria-label": getValueAsString(option.value) })),
            React.createElement(Grid, { item: true, className: classes.valueText },
                React.createElement("span", { className: `value-text` }, getValueAsString(option.value)),
                option.secondaryText && React.createElement("span", { className: `${classes.secondaryText} secondary-text` }, option.secondaryText)),
            React.createElement(Grid, { item: true, className: classes.valueCount },
                React.createElement("span", { className: classes.valueCountText },
                    "(",
                    option.count,
                    ")"))));
    });
    const onFilterBoxChange = (e) => {
        setFilterText(e.target?.value || "");
    };
    const filterBoxClearButton = hasEnteredSearchText() ? (React.createElement(InputAdornment, { position: "end", onClick: () => {
            if (!props.disabled) {
                setFilterText("");
            }
        } },
        React.createElement(Button, { iconButton: true, startIcon: React.createElement(ClearIcon, null), "aria-label": "Clear text", variant: "plain", rounded: true, disabled: props.disabled }))) : null;
    const showFilter = hasEnteredSearchText() || showOptionsExpansion;
    const lineHeight = 35;
    const additionalHeight = (showFilter ? 47 : 0) + (showOptionsExpansion ? 30 : 0);
    const refinerGroupBodyStyles = {
        //For max height support 4 rows of wrapping, so add additional leeway on the max.
        maxHeight: isExpanded ? `${lineHeight * 4 * refinerRows.length + additionalHeight + (refinerRows.length == 0 ? 23 : 0)}px` : "0",
        minHeight: isExpanded ? `${lineHeight * refinerRows.length + additionalHeight}px` : "0",
        height: "auto",
        visibility: isExpanded ? "visible" : "collapse",
        transition: "all 500ms ease-out",
        overflow: "hidden",
        flexWrap: "nowrap"
    };
    const showHideAllElement = showOptionsExpansion ? (React.createElement("div", { "aria-hidden": !props.isExpanded },
        React.createElement(Grid, { item: true, container: true, className: `${classes.showHideSelector} show-all-selector`, style: { cursor: props.disabled ? "auto" : "pointer" }, onClick: toggleShowingAll },
            React.createElement(Grid, { item: true, style: { alignSelf: "center" } },
                React.createElement("span", { className: "show-all-text" }, isShowingAll ? strings.ShowLess : strings.ShowMore)),
            React.createElement(Grid, { item: true },
                React.createElement(Button, { iconButton: true, startIcon: isShowingAll ? React.createElement(ExpandLessIcon, null) : React.createElement(ExpandMoreIcon, null), onClick: toggleShowingAll, variant: "plain", rounded: true, "aria-label": `show ${isShowingAll ? "less" : "more"}`, disabled: props.disabled }))))) : null;
    //Disable tslint because the css style type above doesn't match the type declaration for the style prop,
    //even though the unrecognised rules work just fine
    /* eslint-disable */
    return (React.createElement(StyledDiv, null,
        React.createElement(Grid, { item: true, container: true, className: "refiner-group-body", style: refinerGroupBodyStyles, direction: "column" },
            showFilter ? (React.createElement(Grid, { item: true, style: { marginTop: "2px" } },
                React.createElement(TextField, { className: `${classes.filterBox} filter-text`, variant: "outlined", size: "small", disabled: props.disabled, value: searchText, "data-testid": "filter-text", placeholder: strings.SearchFor.replace("{0}", props.refinerGroup.name), onChange: onFilterBoxChange, InputProps: {
                        endAdornment: filterBoxClearButton
                    } }))) : null,
            refinerRows && refinerRows.length > 0 ? refinerRows : React.createElement("span", { className: "no-result-found-placeholder" }, strings.NoResultsFound),
            showHideAllElement)));
    /* eslint-enable */
}
function DateRangeRefinerGroupBody(props) {
    const [from, setFrom] = React.useState(props.refinerGroup?.dateRange?.fromDate || null);
    const [to, setTo] = React.useState(props.refinerGroup?.dateRange?.toDate || null);
    const [error, setError] = useState(false);
    const [validationMessage, setValidationMessage] = useState("");
    const [dateFormat, setDateFormat] = React.useState("MM/dd/yyyy");
    //Set the date format on first render
    React.useEffect(() => {
        const format = getLocalDateFormat();
        setDateFormat(format);
    }, []);
    React.useEffect(() => {
        if (!props.refinerGroup.dateRange) {
            setFrom(null);
            setTo(null);
            setError(false);
            setValidationMessage("");
            return;
        }
        if (props.refinerGroup.dateRange) {
            if (!props.refinerGroup.dateRange.fromDate) {
                setFrom(null);
                setError(false);
                setValidationMessage("");
            }
            if (!props.refinerGroup.dateRange.toDate) {
                setTo(null);
                setError(false);
                setValidationMessage("");
            }
        }
    }, [props.refinerGroup.dateRange]);
    const onChange = (fromDate, toDate) => {
        setFrom(fromDate);
        setTo(toDate);
        if (props.onDateSelectionChanged) {
            props.onDateSelectionChanged({ fromDate, toDate });
        }
        //Comparing dates from the picker, reset time to start of day
        if (fromDate && toDate) {
            if (!isGreaterThanOrEqual(resetTimeOnDate(toDate), resetTimeOnDate(fromDate))) {
                setError(true);
                setValidationMessage("To date cannot be before From Date ");
                return;
            }
            if (isGreaterThanOrEqual(resetTimeOnDate(toDate), resetTimeOnDate(fromDate))) {
                setError(false);
                setValidationMessage("");
            }
        }
        if (!fromDate || !toDate) {
            setError(false);
            setValidationMessage("");
        }
    };
    const height = "45px";
    const refinerGroupBodyStyles = {
        maxHeight: props.isExpanded ? height : "0",
        minHeight: props.isExpanded ? height : "0",
        height: props.isExpanded ? height : "auto",
        visibility: props.isExpanded ? "visible" : "collapse",
        overflow: props.isExpanded ? "visible" : "hidden",
        transition: "all 300ms ease"
    };
    const showHideAllElement = props.isExpanded ? (React.createElement(Grid, { item: true, container: true, className: `${classes.showHideSelector} show-all-selector`, style: { cursor: props.disabled ? "auto" : "pointer", display: props.isExpanded ? "inherit" : "none" } })) : null;
    return (React.createElement(StyledDiv, null,
        React.createElement(Grid, { item: true, container: true, className: "refiner-group-body", style: refinerGroupBodyStyles, direction: "column" },
            React.createElement(DateRangePicker, { style: { width: "100%" }, selectedFromDate: from, selectedToDate: to, hasError: error, validationText: validationMessage, toLabel: "to", onChange: onChange, disabled: props.disabled, className: classes.dateRangePicker, dateFormat: dateFormat }),
            showHideAllElement)));
}
//Prop defaults
RefinerGroupDisplay.defaultProps = {
    disabled: false
};
